import { useEffect, useState } from 'react';

export const useListVirtualization = ({
  trackRef,
  initialRenderCount,
}: {
  trackRef: React.RefObject<HTMLUListElement | null>;
  initialRenderCount: number;
}) => {
  const [visibleIndexes, setVisibleIndexes] = useState<Set<number>>(
    new Set(Array.from({ length: initialRenderCount }, (_, i) => i)),
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number.parseInt(entry.target.getAttribute('data-index') || '0', 10);

          if (entry.isIntersecting) {
            setVisibleIndexes((prev) => {
              const newSet = new Set(prev);
              newSet.add(index);
              return newSet;
            });

            // Stop observing this element after first intersect
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '50px' },
    );

    const placeholders = trackRef.current?.querySelectorAll('[data-index]');
    placeholders?.forEach((el, i) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { visibleIndexes };
};
